import {
  Component,
  Input,
  OnInit,
  ViewChild,
  OnDestroy,
  Type,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { InlineFieldDirective } from './inline-field.directive';
import { InlineFieldInterfaceComponent } from './inline-field-interface.component';
import { TextInlineFieldComponent } from './text-inline-field/text-inline-field.component';
import { DateInlineFieldComponent } from './date-inline-field/date-inline-field.component';
import { DateTimeInlineFieldComponent } from './datetime-inline-field/datetime-inline-field.component';
import { DecimalInlineFieldComponent } from './decimal-inline-field/decimal-inline-field.component';
import { NumberInlineFieldComponent } from './number-inline-field/number-inline-field.component';
import { MoneyInlineFieldComponent } from './money-inline-field/money-inline-field.component';
import { PercentInlineFieldComponent } from './percent-inline-field/percent-inline-field.component';
import { TagsInlineFieldComponent } from './tags-inline-field/tags-inline-field.component';
import { TextAreaInlineFieldComponent } from './textarea-inline-field/textarea-inline-field.component';
import { TypeaheadInlineFieldComponent } from './typeahead-inline-field/typeahead-inline-field.component';
import { SelectInlineFieldComponent } from './select-inline-field/select-inline-field.component';
import { YearInlineFieldComponent } from './year-inline-field/year-inline-field.component';
import { CheckboxInlineFieldComponent } from './checkbox-inline-field/checkbox-inline-field.component';
import { UrlInlineFieldComponent } from './url-inline-field/url-inline-field.component';
import { RecordInlineFieldComponent } from './record-inline-field/record-inline-field.component';

const inlineFieldComponent = {
  text: TextInlineFieldComponent,
  date: DateInlineFieldComponent,
  datetime: DateTimeInlineFieldComponent,
  decimal: DecimalInlineFieldComponent,
  number: NumberInlineFieldComponent,
  money: MoneyInlineFieldComponent,
  percent: PercentInlineFieldComponent,
  tags: TagsInlineFieldComponent,
  textarea: TextAreaInlineFieldComponent,
  typeahead: TypeaheadInlineFieldComponent,
  select: SelectInlineFieldComponent,
  year: YearInlineFieldComponent,
  checkbox: CheckboxInlineFieldComponent,
  url: UrlInlineFieldComponent,
  record: RecordInlineFieldComponent,
};

@Component({
  selector: 'app-inline-field',
  templateUrl: './inline-field.component.html',
  styleUrls: ['./inline-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InlineFieldComponent implements OnInit {
  @Input() fieldDef: any;
  @Input() model: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() canClick: boolean = false;
  @Input() showEmptyHolder: boolean = false;
  @Output() onUpdate: EventEmitter<string> = new EventEmitter();
  @Output() onClick: EventEmitter<string> = new EventEmitter();
  @ViewChild(InlineFieldDirective, { static: true }) inlineFieldHost: InlineFieldDirective;

  ngOnInit(): void {
    this.loadComponent();
  }

  loadComponent(): void {
    if (this.fieldDef?.type && inlineFieldComponent[this.fieldDef.type]) {
      const viewContainerRef = this.inlineFieldHost.viewContainerRef;
      viewContainerRef.clear();

      const componentRef = viewContainerRef.createComponent(inlineFieldComponent[this.fieldDef.type]);
      const componentInstance = componentRef.instance as InlineFieldInterfaceComponent;
      componentInstance.model = this.model;
      componentInstance.fieldDef = this.fieldDef;
      componentInstance.data = this.data;
      componentInstance.readonly = this.readonly;
      componentInstance.excludeLabels = this.excludeLabels;
      componentInstance.update = this.onUpdate;
      componentInstance.onClick = this.onClick;
      componentInstance.canClick = this.canClick;
      componentInstance.showEmptyHolder = this.showEmptyHolder;
    }
  }
}
